import HouseStatus from 'types/houseStatus';

export default function getHouseStatus(booked: number, bookable: boolean) {
    if (booked > 0) return HouseStatus.BOOKED;
    if (bookable) return HouseStatus.AVAILABLE;
    return HouseStatus.UNAVAILABLE;
}
